/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */

export default {
    // every plugin for Vue.js needs install method
    // this method will run after Vue.use(<your-plugin-here>) is executed
    install(Vue, options) {
        // We must create new Eventbus
        // which is just another Vue instance that will be listening for and emiting events from our main instance
        // this EventBus will be available as Modal.EventBus
        this.EventBus = new Vue()

        Vue.prototype.$highlight = {
            createOnElementClass(elementId, query, htmlElement, highlightClass) {
                query.map(value => {
                    htmlElement.innerHTML = this.create(
                        elementId,
                        value,
                        htmlElement.innerHTML,
                        highlightClass
                    )
                })
            },
            create(elementId, query, content, highlightClass) {
                try{
                    if (!query) {
                        return content
                    }
                    return content.replace(new RegExp(query, 'g'), (match) => {
                        return `<span id="highlight-${elementId}" class="highlight ${highlightClass}">${match}</span>`
                    })
                }catch(err) {
                    console.error(err)
                }
                return content
            },
            delete(elementId, elementClass, highlightClass, text) {
                const content = document.querySelector(elementClass)
                if (content) {
                    text.map(value => {
                        content.innerHTML = this.cleanElement(
                            elementId,
                            content.innerHTML,
                            highlightClass,
                            value
                        )
                    })

                }
            },
            cleanElement(elementId, content, highlightClass, text) {
                const query = `<span id="highlight-${elementId}" class="highlight ${highlightClass}">${text}</span>`
                const el = document.getElementById(`highlight-${elementId}`)
                if(el) {
                    const cleanText = el.textContent
                    return content.replace(new RegExp(query, 'g'), () => {
                        return cleanText
                    })
                }

                return content
            },
            setHighlighType(type) {
                switch (type) {
                    case 0:
                        return 'characters'
                    case 1:
                        return 'actions'
                    case 2:
                        return 'vocabulary'
                    case 3:
                        return 'places'
                    default:
                        return ''
                }
            },
        }
    },
}
